import { InjectionToken } from '@angular/core';

export const Window = new InjectionToken<Window>('Window', { // eslint-disable-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
    providedIn: 'root',
    factory: () => window
});